import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { useAuth } from './useAuth'
import { isSupplier } from '../lib/supplier'
import useLoginModal from './useLoginModal'
import { LOCAL_STORAGE_USER_KEY } from '../utils/constants'
import { getLocalStorageUserData } from '../utils/localStorage'

const ignoreOnUrls = ['/login', '/apply', 'register', '/logout', '/password']

function useRequireAuth(redirectUrl = '/login') {
  const auth = useAuth()
  const { openLoginModal } = useLoginModal()
  const router = useRouter()

  const { user } = auth
  const isSupplierUser = isSupplier(user)
  const isOnIgnoreUrl = ignoreOnUrls.some((url) => router.asPath?.includes(url))

  useEffect(() => {
    // Ignore this auth check when running Cypress tests with IGNORE_AUTH_REDIRECT env variable
    if (window.Cypress && window.Cypress.env('IGNORE_AUTH_REDIRECT')) {
      return
    }

    const localStorageUser = getLocalStorageUserData(LOCAL_STORAGE_USER_KEY)

    if (!auth || !user || !localStorageUser || isOnIgnoreUrl) {
      if (isSupplierUser) {
        router.push(redirectUrl)
      } else if (!localStorageUser) {
        // If buyer user then open modal on the same page
        setTimeout(() => {
          openLoginModal()
        }, 500) // To open login modal asynchronously
      }
    }
  }, [router.route])

  useEffect(() => {
    const checkUserData = () => {
      const localStorageUser = getLocalStorageUserData(LOCAL_STORAGE_USER_KEY)

      if (!localStorageUser) {
        router.push(redirectUrl)
      }
    }

    window.addEventListener('storage', checkUserData)

    return () => {
      window.removeEventListener('storage', checkUserData)
    }
  }, [])

  return auth
}

export default useRequireAuth
